export enum RoutesShortWandP {
  Login = 'login',
  Detail = 'detail',
  New = 'new',
  Id = ':id',
  Inspections = 'inspections',
  Punches = 'punches',
  Consolidations = 'consolidations',
  UsersSetup = 'users-setup',
  AlertsSetup = 'alerts-setup',
  RootConfiguration = 'wap/configuration/',
  Templates = 'templates',
  TemplatesDetail = 'project-detail',
  TemplatesGlobal = 'global-detail',
  MasterTables = 'master-tables',
  TemplatesGlobalCollections = 'global-collections',
  TemplatesProjectCollections = 'project-collections',
  Projects = 'projects',
  LiveReports = 'live-reports',
  Maps = 'maps',
  Reports = 'reports',
  Common = 'common',
  Downloads = 'downloads',
  Process = 'process',
  ProjectProcess = 'project-process',
  MaintenanceConfig = 'maintenanceConfig',
  Maintenance = 'maintenance',
  SignedPunches = 'signed-punches',
  Update = 'update',
  ProjectSetup = 'project-setup',
  ProjectOverview = 'project-overview',
  ProjectSettings = 'project-settings',
  WbsTree = 'wbs-tree',
  TemplateConfiguration = 'template-configuration',
  TemplateOverview = 'template-overview',
  TemplateSettings = 'template-settings',
  InspectionTypes = 'inspection-types',
  CustomFields = 'custom-fields',
  Users = 'users',
  Roles = 'roles',
  Audit = 'audit',
}

export enum TextMenu {
  Main = 'Main',
  WP_Administration = 'W&P Administration',
  ProjectSetup = 'Project Setup',
  TemplateConfiguration = 'Template Configuration',
  Admin = 'Admin',
  Inspections = 'Inspections',
  Punches = 'Punches',
  Consolidations = 'Consolidations',
  Users = 'Users',
  MasterTables = 'Master Tables',
  Alerts = 'Alerts',
  Configuration = 'Configuration',
  Templates = 'Templates',
  Projects = 'Projects',
  LiveReports = 'Live Reports',
  Maps = 'Maps',
  Reports = 'BI Reports',
  Downloads = 'Downloads',
  Process = 'Processes',
  ProjectProcess = 'Project Processes',
  SignedPunches = 'Wet Signed Punches',
  MaintenanceConfig = 'Maintenance Config',
  ProjectOverview = 'Project Overview',
  ProjectSettings = 'Project Settings',
  ProjectTemplates = 'Project Templates',
  WbsTree = 'WBS Tree',
  TemplateOverview = 'Template Overview',
  TemplateSettings = 'Template Settings',
  InspectionTypes = 'Inspection Types',
  CustomFields = 'Custom Fields',
  UsersManagement = 'W&P Users',
  Roles = 'Roles',
  Audit = 'Audit',
}

export enum InvitationRoutesEnum {
  AcceptInvitation = 'AcceptInvitation'
}

export enum InvitationParamsEnum {
  key = 'key',
  accept = 'accept'
}

export enum PunchesDetailEnum {
  nodeId = 'nodeId',
  projectId = 'projectId',
  templateId = 'templateId',
  punchId = 'punchId'
}
